import React, {useState} from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "./style.css"; // Arquivo CSS personalizado
import { Modal } from 'react-responsive-modal';
import { NextArrow, PrevArrow } from "./arrows";

const ResponsiveCarousel = ({images = [], imageField = '',redirect = false, urlField = ''}) => {
  const settings = {
    dots: true,
    infinite: true,
    speed: 1500,
    autoplay: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    adaptiveHeight: true,
    centerMode: false, 
    nextArrow: <NextArrow/>,
    prevArrow: <PrevArrow/>
  };

  const [open, setOpen] = useState(false);
  const [imgIndex, setImgIndex] = useState(0);
  const onOpenModal = () => setOpen(true);
  const onCloseModal = () => setOpen(false);
  return (
    <div className="carousel-container">
      <Modal classNames={{
        modal: 'custom-modal-carousel',
      }} open={open} onClose={onCloseModal} >
        <img className='modal-image' src={imageField? images[imgIndex][imageField]: images[imgIndex]} alt={`Slide ${imgIndex}`} />

      </Modal>
      <Slider {...settings}>
        {images.map((image, index) => (
          <div key={index} className="carousel-slide">
            <img src={imageField ? image[imageField]: image} onClick={() => {
              setImgIndex(index)
              console.log('clicou', image)
              if(redirect && image[urlField])
                window.open(image[urlField])  
              else
                onOpenModal()
            }} alt={`Slide ${index}`} />
          </div>
        ))}
      </Slider>
    </div>
  );
};

export default ResponsiveCarousel;
